import { withStyles } from '@material-ui/core';
import Label from './common/Label';
import Detail from './common/Detail';
import appConstants from '../../../../../appConstants';
import { getFormattedValue } from './utils';

const styles = () => ({
  detailsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    '&>div:nth-child(n)': {
      marginTop: 8
    }
  },
  container: {
    margin: '16px 0px'
  },
  valueClass: {
    width: '100%',
    marginTop: 4,
    marginRight: 16
  },
  detailContainer: {
    flexGrow: 1
  }
});
const ReceiverDetails = ({ classes, proData }) => {
  const getReceiverDetails = () => {
    if (proData.deliveryCode === appConstants.DELIVERY_CODE.TA) {
      return {
        sectionLabel: 'Agent Details',
        name: getFormattedValue(proData.agentDetail?.name),
        email: getFormattedValue(proData.agentDetail?.email),
        phone: getFormattedValue(proData.agentDetail?.phone)
      };
    }
    return {
      sectionLabel: 'Receiver Details',
      name: getFormattedValue(proData.receiverDetails?.receiverName),
      email: getFormattedValue(proData.receiverDetails?.receiverEmail),
      phone: getFormattedValue(proData.receiverDetails?.receiverCellPhone)
    };
  };
  const { sectionLabel, name, email, phone } = getReceiverDetails();
  return (
    <div className={classes.container}>
      <Label labelText={sectionLabel} />
      <div className={classes.detailsContainer}>
        <Detail
          label="Name"
          value={name}
          customValueClasses={classes.valueClass}
          detailContainerClasses={classes.detailContainer}
        />
        <Detail
          label="Email"
          value={email}
          customValueClasses={classes.valueClass}
          detailContainerClasses={classes.detailContainer}
        />
        <Detail
          label="Contact"
          value={phone}
          customValueClasses={classes.valueClass}
          detailContainerClasses={classes.detailContainer}
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(ReceiverDetails);
